import React, {useEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import {setLookOpened,
  setSidebarModalOpened,
  setLookActiveFeature,
  setLookActiveCategory} from "../../../../actions/lookFunctions";
import LookSideBarLayoutButton from "./lookSideBarLayoutButton";
import LookSideBarSaveButton from "./lookSideBarSaveButton";
// import LookSideBarHomeButton from "./lookSideBarHomeButton";
import LookSideBarEditButton from "./lookSideBarEditButton";
import LookSideBarMoreButton from "./lookSideBarMoreButton";
import LookSideBarFiltersButton from "./lookSideBarFiltersButton";
import {LOOK_INTRO_STEPS, LOOK_OVERLAYS} from "../../core/constants";
import {zoomCanvasOut} from "../lookFunctions";
import {setCanvasScale} from "../../../../actions/actionFunctions";
import LookSideBarPingPilotButton from "./lookSideBarPingPilotButton";
import LookSideBarRevertButton from "./lookSideBarRevertButton";
import WithUpdateLookCartItem from "../../hocs/withUpdateLookCartItem";
import {useShowRoomLayoutsButton} from "../../../../misc/helperHooks";

const LookSidebar = (props) => {

  const {popupCloseClick, imageCanvas, lookOverlayOpened, lookPageOpened, isMobile, introStep, lookOpened, setLookOpened,
    setCanvasScale, setLookActiveFeature, setLookActiveCategory, activePreset, visualizersLoadedLength} = props;

  const highLightForDemo = [LOOK_INTRO_STEPS.wallsAndFloor, LOOK_INTRO_STEPS.layoutsAndRooms, LOOK_INTRO_STEPS.saveAndMore];

  const stylePopups = [LOOK_OVERLAYS.stylePairing, LOOK_OVERLAYS.styleColor, LOOK_OVERLAYS.styleRemove, LOOK_OVERLAYS.styleRemoveBack];
  const stylePopupOnMobile = isMobile && stylePopups.some(popupType => popupType === lookOverlayOpened);

  useEffect(() => {
    // if (lookPageOpened || lookOverlayOpened) {
    if (lookPageOpened) {
      zoomCanvasOut(imageCanvas, setCanvasScale)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookPageOpened, lookOverlayOpened])

  const sidebarButtonClicked = () => { // closes opened menu and zooms out canvas
    if (lookOpened) {
      setLookOpened(null);
      setLookActiveCategory("");
      setLookActiveFeature(null);
    }
    // revertFeatureBeforeChange(updateCanvasCount);
    zoomCanvasOut(imageCanvas, setCanvasScale);
  }

  const showRoomLayoutsButton = useShowRoomLayoutsButton(activePreset, isMobile, visualizersLoadedLength);

  return (
    <aside className={"look-sidebar"
    + (stylePopupOnMobile || highLightForDemo.includes(introStep) ? " look-sidebar--on-top look-sidebar--intro" : "")}>
      <ul className="look-sidebar__list">
        {/*<LookSideBarHomeButton popupCloseClick={popupCloseClick}*/}
        {/*                       sidebarButtonClicked={sidebarButtonClicked}*/}
        {/*                       disabled={stylePopupOnMobile}/>*/}
        <LookSideBarEditButton popupCloseClick={popupCloseClick}
                               sidebarButtonClicked={sidebarButtonClicked}
                               disabled={stylePopupOnMobile}/>
        <WithUpdateLookCartItem>
          {(updateLookCartItem) => <LookSideBarRevertButton popupCloseClick={popupCloseClick}
                                                            showRoomLayoutsButton={showRoomLayoutsButton}
                                                            updateLookCartItem={updateLookCartItem}
                                                            sidebarButtonClicked={sidebarButtonClicked}
                                                            disabled={stylePopupOnMobile}/>}
        </WithUpdateLookCartItem>
        <LookSideBarFiltersButton popupCloseClick={popupCloseClick}
                                  disabled={stylePopupOnMobile}/>
        <LookSideBarLayoutButton popupCloseClick={popupCloseClick}
                                 showRoomLayoutsButton={showRoomLayoutsButton}
                                 sidebarButtonClicked={sidebarButtonClicked}
                                 disabled={stylePopupOnMobile}/>
        <LookSideBarSaveButton popupCloseClick={popupCloseClick}
                               sidebarButtonClicked={sidebarButtonClicked}
                               disabled={stylePopupOnMobile}/>
        <LookSideBarPingPilotButton popupCloseClick={popupCloseClick}
                                    sidebarButtonClicked={sidebarButtonClicked}
                                    disabled={stylePopupOnMobile}/>
        <LookSideBarMoreButton popupCloseClick={popupCloseClick}
                               sidebarButtonClicked={sidebarButtonClicked}
                               disabled={stylePopupOnMobile}/>
      </ul>
    </aside>
  )
};

LookSidebar.propTypes = {
  popupCloseClick: PropTypes.func,
  imageCanvas: PropTypes.object,
};

const mapStateToProps = (store) => {
  const {lookOpened, lookOverlayOpened, lookPageOpened, introStep} = store.lookState;
  const {activeTheme, isMobile, visualizersLoaded} = store.serverState;
  const {activePreset} = store.bathroomVisualizerState;

  return {
    lookOpened,
    activeTheme,
    lookOverlayOpened,
    isMobile,
    introStep,
    lookPageOpened,
    activePreset,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setSidebarModalOpened,
  setCanvasScale,
  setLookActiveFeature,
  setLookActiveCategory,
};

export default withRouter(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(LookSidebar))
)
